import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetGroup } from '../models/product/dto/asset-group';
import { AddAssetModalComponent } from '../views/shared/modals/add-asset-modal/add-asset-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';

export class ModalAddAsset {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    assetGroup: AssetGroup,
    onClose?: (ags: AssetGroup[]) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(AddAssetModalComponent, ModalUtils.addAssetModalOptions(injector));
      const compInstance = modalRef.componentInstance as AddAssetModalComponent;
      compInstance.setAssetGroup(assetGroup);
      modalRef.result
        .then(updatedAssetGroups => {
          if (exists(updatedAssetGroups)) {
            onClose?.(updatedAssetGroups);
          }
        })
        .catch();
    });
  }
}
